import { error } from 'services/graphql/fragments/Fragments';
import { AnalyticsFragment } from 'services/graphql/fragments/VxlFragments';
import { gql } from 'urql';

const FetchDebtSaleDetails = gql`
  query debtSaleDetails {
    debtSaleDetails {
      ... on DebtSaleDetailsSuccess {
        __typename
        id
        pageTitle: title
        footnote
        accounts {
          id
          productName
          subtitle
          paymentInstructions
          buyer {
            id
            name
          }
          paymentPortalButton {
            label
            contactMethod {
              id
              type
              label
              action {
                id
                deeplink
                analyticsEvent {
                  ...analytics
                }
              }
            }
          }
        }
      }
      ... on DebtSaleDetailsNoDebt {
        __typename
        id
      }
      ... on DebtSaleDetailsError {
        __typename
        ...error
      }
    }
  }
  ${AnalyticsFragment}
  ${error}
`;

export default FetchDebtSaleDetails;
